class ScrollLock {
	#state = $state({
		locked: false,
		lastOverflow: ''
	});

	get isLocked() {
		return this.#state.locked;
	}

	lock() {
		if (this.isLocked) return;

		const html = document.documentElement;
		this.#state.lastOverflow = html.style.getPropertyValue('overflow');
		this.#state.locked = true;
		html.style.setProperty('overflow', 'hidden');
	}

	unlock() {
		if (!this.isLocked) return;

		const html = document.documentElement;
		html.style.setProperty('overflow', this.#state.lastOverflow);
		this.#state.locked = false;
	}
}

export const scrollLock = new ScrollLock();
